<section class="runner-connect" data-testid="connect-help" [attr.aria-labelledby]="ids.title">
  <div class="runner-connect__kopf">
    <h3 class="runner-connect__titel" [id]="ids.title" data-testid="connect-title">
      {{ 'runnerConnect.title' | translate }}
    </h3>
    @if (closable()) {
      <button
        type="button"
        class="runner-connect__schliessen"
        data-testid="connect-close"
        [attr.aria-label]="'runnerConnect.close' | translate"
        (click)="closed.emit()"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    }
  </div>
  <p class="runner-connect__einleitung" data-testid="connect-intro">{{ 'runnerConnect.intro' | translate }}</p>
  <ol class="runner-connect__schritte">
    @for (step of steps; track step) {
      <li data-testid="connect-step">{{ 'runnerConnect.steps.' + step | translate }}</li>
    }
  </ol>

  @if (packagesState() === 'failed') {
    <p class="runner-connect__meldung" role="alert" data-testid="connect-packages-failed">
      {{ 'runnerPairing.packages.loadFailed' | translate }}
    </p>
  } @else if (packagesState() === 'loaded' && packages().length === 0) {
    <p class="runner-connect__meldung runner-connect__meldung--info" role="status" data-testid="connect-packages-none">
      {{ 'runnerPairing.packages.none' | translate }}
    </p>
  } @else if (packages().length > 0) {
    <div class="runner-connect__pakete">
      @for (platform of packages(); track platform) {
        <button
          mat-stroked-button
          type="button"
          class="runner-connect__paket"
          data-testid="connect-package"
          [disabled]="downloading() !== null"
          (click)="download(platform)"
        >
          @if (downloading() === platform) {
            <mat-progress-spinner mode="indeterminate" diameter="14" />
          } @else {
            <span aria-hidden="true">⤓</span>
          }
          {{ 'runnerPairing.platform.' + platform | translate }}
        </button>
      }
    </div>
  }
  @if (downloadStarted(); as platform) {
    <p class="runner-connect__meldung runner-connect__meldung--ok" role="status" data-testid="connect-download-started">
      {{
        'runnerConnect.downloadStarted' | translate: { platform: ('runnerPairing.platform.' + platform | translate) }
      }}
    </p>
  }
  @if (downloadFailed()) {
    <p class="runner-connect__meldung" role="alert" data-testid="connect-download-error">
      {{ 'runnerPairing.error.downloadFailed' | translate }}
    </p>
  }

  @switch (right()) {
    @case ('allowed') {
      <label class="runner-connect__code-label" [for]="ids.code">{{ 'runnerConnect.codeLabel' | translate }}</label>
      <div class="runner-connect__code-zeile">
        <input
          #codeFeld
          class="runner-connect__code"
          data-testid="connect-code"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          [id]="ids.code"
          [attr.aria-describedby]="ids.hint"
          [placeholder]="'runnerConnect.codePlaceholder' | translate"
          [value]="code()"
          (input)="onCodeInput(codeFeld)"
          (keydown.enter)="$event.preventDefault(); submit()"
        />
        <button
          mat-flat-button
          type="button"
          class="runner-connect__verbinden"
          data-testid="connect-submit"
          [disabled]="!canSubmit()"
          (click)="submit()"
        >
          @if (busy()) {
            <mat-progress-spinner mode="indeterminate" diameter="16" />
          }
          {{ 'runnerConnect.submit' | translate }}
        </button>
      </div>
      <p class="runner-connect__hinweis" data-testid="connect-hint" [id]="ids.hint">
        {{ 'runnerConnect.hint' | translate }}
      </p>
      @if (connectedRunner(); as runnerName) {
        <p class="runner-connect__meldung runner-connect__meldung--ok" role="status" data-testid="connect-success">
          {{ 'runnerConnect.success' | translate: { name: runnerName } }}
        </p>
      }
      @if (connectError(); as messageKey) {
        <p class="runner-connect__meldung" role="alert" data-testid="connect-error">{{ messageKey | translate }}</p>
      }
    }
    @case ('denied') {
      <p class="runner-connect__keine-rechte" data-testid="connect-no-rights">
        {{ 'runnerConnect.noRights' | translate }}
      </p>
    }
  }
</section>
